class RecommendedTitles extends React.Component {

  render() {
    return (
      <div className="row gutter_left gutter_right recommended_titles" style={{marginBottom: "30px", textAlign: "center"}}>
        <a href={this.props.post.permalink} style={{color: "#fff"}} dangerouslySetInnerHTML={{__html: this.props.post.title}}></a>
      </div>
    );
  }
}
